// extracted by mini-css-extract-plugin
export default {"mixin":"BarChart_mixin__Cpjli","container":"BarChart_container__9bikU","label":"BarChart_label__i8HVh"};